<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>주차요금정산</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">주차요금정산</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">미납주차요금</p>
          <ul class="depth">
            <!--<li><router-link to="/prepaymentinfo" title="요금사전결제">요금사전결제</router-link></li>-->
            <li><router-link to="/unpaidinfo" title="미납주차요금">미납주차요금</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">미납요금 조회/결제</p>
          <ul class="depth">
            <li><router-link to="/unpaidinfo" title="미납요금 납부안내">미납요금 납부안내</router-link></li>
            <li>
              <router-link to="/lookupunpaid" title="미납요금 조회/결제"
                >미납요금 조회/결제</router-link
              >
            </li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">미납 요금 조회</h3>
        <article class="selectOpt type02">
          <dl>
            <dt>
              <h4 class="tit">차량번호 조회</h4>

              <p class="subTxt">미납된 주차요금을 조회/결제하실 수 있습니다. <br/>전체 차량 번호를 입력해 주세요.</p>
            </dt>
            <dd>
              <p>차량번호</p>
              <input
                type="text"
                title="차량번호 입력"
                placeholder="123가4567"
                v-model="carNo"
                maxlength="10"
                @keyup.enter="searchUnpaid"
              />
              <button type="button" class="btn dkGray" @click="searchUnpaid">조회</button>
            </dd>
          </dl>
        </article>
        <article>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="tap-container">
              <button class="tap-btn" :class="{ active : isOffSt }" @click="switchingList(true)">노외주차장 <span>({{offStCnt}}건)</span></button>
              <button class="tap-btn" :class="{ active : !isOffSt }" @click="switchingList(false)">노상주차장 <span>({{stCnt}}건)</span></button>
            </div>
            <div class="table vertical-table">
              <table>
                <caption>
                  차량번호 조회 테이블
                </caption>
                <thead>
                  <tr>
                    <th scope="col">
                      <p class="checkbox">
                        <input type="checkbox" id="chk-all" class="hidden" v-model="checkAll" @change="checkAllList" v-bind:disabled="unpaidList.length == 0"/>
                        <label for="chk-all"></label>
                      </p>
                    </th>
                    <th scope="col">번호</th>
                    <th scope="col">차량번호</th>
                    <th scope="col">주차장</th>
                    <th scope="col">입차일시</th>
                    <th scope="col">출차일시</th>
                    <th scope="col">미납주차료</th>
                    <th scope="col">가산금</th>
                    <th scope="col">미납총액</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="isOffSt">
                    <tr class="nodate" v-if="offStCnt == 0">
                      <td colspan="9" v-if="offStIsLoading"><loading-spinner></loading-spinner></td>
                      <td colspan="9" v-else>조회된 데이터가 없습니다.</td>
                    </tr>
                  </template>
                  <template  v-if="!isOffSt">
                    <tr class="nodate" v-if="stCnt == 0">
                      <td colspan="9" v-if="stIsLoading"><loading-spinner></loading-spinner></td>
                      <td colspan="9" v-else>조회된 데이터가 없습니다.</td>
                    </tr>
                  </template>
                  <tr v-for="(item, index) in unpaidList" :key="index">
                    <td>
                      <p class="checkbox">
                        <input type="checkbox" :id="item.id" :value="item.id" v-model="checkedList" @change="getIsChecked(item)" />
                        <label :for="item.id" />
                      </p>
                    </td>
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.carNo }}</td>
                    <td>{{ item.parkingName }}</td>
                    <td>{{ item.inDttm }}</td>
                    <td>{{ item.outDttm == null ? '-' : item.outDttm }}</td>
                    <td>{{ item.unpaidAmt | comma }}</td>
                    <td>{{ item.addAmt | comma }}</td>
                    <td>{{ item.sumAmt | comma }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <p class="info">결제를 원하시는 미납 요금에 체크 하신 후 결제를 진행해주세요.</p>
          <p class="info">할인/감면이 필요한 경우 결제 전 주차사업팀 사무실(031-635-2070)로 연락바랍니다.</p>
          <p class="info">이천시 노외주차장: 공설운동장, 남천상가, 북샛말, 서희청소년문화센터, 택시쉼터, 중리천로, 터미널주차장(8-2)</p>
        </article>
        <article class="resultBox">
          <div class="result">
            <div class="txt">
              미납금액 합계
              <div class="pay">{{ totalSumAmt | comma }}</div>
              원
            </div>
            <button type="button" class="btn mint" @click="unpaidPaymentView">미납요금 결제</button>
          </div>
        </article>
      </div>
    </section>

    <!-- 알럿 -->
    <alert-notmatch v-show="showModalMsgFailure">
      <template #content>
        <p>{{ modalMsg }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="CloseBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-notmatch>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import AlertNotmatch from '../../../components/Alert02.vue';
import LoadingSpinner from '../../../components/LoadingSpinner.vue';
export default {
  data() {
    return {
      showModalMsgFailure: false,
      modalMsg: '',

      carNo: '',
      unpaidList: [],
      checkedList: [],
      totalUnpaidAmt: 0,
      totalAddAmt: 0,
      totalSumAmt: 0,
      unpaidItems: [],
      checkAll: false,
      unpaidData: {},
      totalCnt: 0,
      
      offStIsLoading: false,
      stIsLoading: false,
      
      isOffSt: true,
      
      offStUnpaidList: [],
      offStUnpaidData: {},
      offStCnt: 0,
      stUnpaidList: [],
      stUnpaidData: {},
      stCnt: 0,
    };
  },
  
  mounted() {
    let beforeCarNo = this.$route.params.carNo;
    if(beforeCarNo) {
      this.carNo = beforeCarNo;
      this.searchUnpaid();
    }
  },

  components: {
    AlertNotmatch,
    LoadingSpinner,
  },

  methods: {
    CancleBtn() {
      this.showModalMsgFailure = false;
    },

    CloseBtn() {
      this.showModalMsgFailure = false;
    },

    validateSearchUnpaid() {
      const carNoRegex = /^\s*([가-히]{2}){0,1}\s*[0-9]{1,3}[\s]*[가-히]{1}[\s]*[0-9]{4}\s*$/gi;
      if (!this.carNo || !carNoRegex.test(this.carNo)) {
        this.modalMsg = '차량번호 형식에 맞지 않습니다.';
        this.showModalMsgFailure = true;
        return false;
      }
      return true;
    },
        
    clearList() {
      this.unpaidList = [];
      this.unpaidData = {};
      
      this.offStUnpaidList = [];
      this.offStUnpaidData = {};
      this.offStCnt = 0;
      
      this.stUnpaidList = [];
      this.stUnpaidData = {};
      this.stCnt = 0;
    },
    
    unpaidItemClear() {
      this.totalAddAmt = 0;
      this.totalSumAmt = 0;
      this.totalUnpaidAmt = 0;
      this.totalCnt = 0;
      
      this.checkedList = [];
      this.unpaidItems = [];
    },
    
    switchingList(isTrue) {
      
      this.isOffSt = isTrue;
      this.checkAll = false;
      this.unpaidItemClear();
      
      if(this.isOffSt) {
        this.unpaidList = this.offStUnpaidList;
        this.unpaidData = this.offStUnpaidData;
      }else {
        this.unpaidList = this.stUnpaidList;
        this.unpaidData = this.stUnpaidData;
      }
    },

    searchUnpaid() {
      if (!this.validateSearchUnpaid()) return;

      this.offStIsLoading = true;
      this.stIsLoading = true;
      
      this.checkAll = false;
      this.clearList();
      this.unpaidItemClear();
      
      this.searchUnpaidTpms().then(() => {
        this.offStIsLoading = false;
        this.switchingList(true);
      });
      
      this.searchUnpaidKnl().then(() => {
        this.stIsLoading = false;
      });
    },
    
    //tpms 노외 주차장 미납 조회
    async searchUnpaidTpms() {
      const res = await axios('get', '/api/unpaid/searchUnpaidList.json', {
        carNo: this.carNo,
      });

      const data = res.data?.value;
      if (!data || Object.keys(data).length == 0) return;
      
      this.offStCnt = data.cnt;
      this.offStUnpaidList = data.result;
      this.offStUnpaidData = data;
    },
    
    //knl 노상 주차장 미납 조회
    async searchUnpaidKnl() {
      const res = await axios('get', '/api/unpaid/searchUnpaidListKnl.json', {
        carNo: this.carNo,
      });
      
      const data = res.data?.value;
      if (!data || Object.keys(data).length == 0) return;
      
      this.stCnt = data.cnt;
      this.stUnpaidList = data.result;
      this.stUnpaidData = data;
    },

    getIsChecked(unpaid) {
      let operator = this.checkedList.includes(unpaid.id) ? 1 : -1;
      let isAll = this.checkedList.length == this.unpaidList.length;
      
      this.totalCnt += operator;
      this.totalAddAmt += (unpaid.addAmt * operator);
      this.totalSumAmt += (unpaid.sumAmt * operator);
      this.totalUnpaidAmt += (unpaid.unpaidAmt * operator);
      this.checkAll = isAll;
      
      if(operator > 0) {
        
        this.unpaidItems.push(unpaid);
        
      } else {
        for(var i = 0; i < this.unpaidItems.length; i++) {
          if(this.unpaidItems[i].id == unpaid.id) {
            this.unpaidItems.splice(i, 1);
          }
        }
      }
      
    },

    checkAllList() {
      
      this.unpaidItemClear();
      if(!this.checkAll) return;
      
      for (const unpaid of this.unpaidList) this.checkedList.push(unpaid.id);
      
      this.totalAddAmt = this.unpaidData.totAddAmt;
      this.totalUnpaidAmt = this.unpaidData.totUseAmt;
      this.totalSumAmt = this.totalAddAmt + this.totalUnpaidAmt;
      this.totalCnt = this.checkedList.length || 0;
      
      for (const unpaid of this.unpaidList) this.unpaidItems.push(unpaid);
    },

    unpaidPaymentView() {
      
      if (this.checkedList.length == 0 || this.unpaidList.length == 0) {
        this.modalMsg = '결제할 미납 내역을 선택해주세요.';
        this.showModalMsgFailure = true;
        return;
      }

      const params = {
        inOutIds: this.checkedList.join(','),
        carNo: this.carNo,
        totalSumAmt: this.totalSumAmt,
        totalUnpaidAmt: this.totalUnpaidAmt,
        totalAddAmt: this.totalAddAmt,
        totalCnt: this.totalCnt,
        isOffSt: this.isOffSt,
        items: this.unpaidItems,
      };

      this.$router.push({
        name: 'unpaidview',
        params: { data: params },
      });
    },
    
  },
};

</script>
